export const generateUniqId = (radix?: number, substringStart = 7): string =>
  Math.random().toString(radix).substring(substringStart);
